export * from './app.service';
import { AppService } from './app.service';
export * from './businessTypes.service';
import { BusinessTypesService } from './businessTypes.service';
export * from './businessTypesForUnion.service';
import { BusinessTypesForUnionService } from './businessTypesForUnion.service';
export * from './cC.service';
import { CCService } from './cC.service';
export * from './chats.service';
import { ChatsService } from './chats.service';
export * from './cities.service';
import { CitiesService } from './cities.service';
export * from './codeSend.service';
import { CodeSendService } from './codeSend.service';
export * from './committeeSubscriptions.service';
import { CommitteeSubscriptionsService } from './committeeSubscriptions.service';
export * from './committeeUserSubscriptions.service';
import { CommitteeUserSubscriptionsService } from './committeeUserSubscriptions.service';
export * from './committees.service';
import { CommitteesService } from './committees.service';
export * from './contacts.service';
import { ContactsService } from './contacts.service';
export * from './contactsForUser.service';
import { ContactsForUserService } from './contactsForUser.service';
export * from './customLists.service';
import { CustomListsService } from './customLists.service';
export * from './dashboard.service';
import { DashboardService } from './dashboard.service';
export * from './documents.service';
import { DocumentsService } from './documents.service';
export * from './event.service';
import { EventService } from './event.service';
export * from './invites.service';
import { InvitesService } from './invites.service';
export * from './jobTitles.service';
import { JobTitlesService } from './jobTitles.service';
export * from './jobTitlesForUnion.service';
import { JobTitlesForUnionService } from './jobTitlesForUnion.service';
export * from './labelItems.service';
import { LabelItemsService } from './labelItems.service';
export * from './loyalty.service';
import { LoyaltyService } from './loyalty.service';
export * from './loyaltyCodesForProduct.service';
import { LoyaltyCodesForProductService } from './loyaltyCodesForProduct.service';
export * from './loyaltyCollection.service';
import { LoyaltyCollectionService } from './loyaltyCollection.service';
export * from './loyaltyFavoriteProduct.service';
import { LoyaltyFavoriteProductService } from './loyaltyFavoriteProduct.service';
export * from './loyaltyRequests.service';
import { LoyaltyRequestsService } from './loyaltyRequests.service';
export * from './loyaltySearch.service';
import { LoyaltySearchService } from './loyaltySearch.service';
export * from './mails.service';
import { MailsService } from './mails.service';
export * from './newsletterTemplates.service';
import { NewsletterTemplatesService } from './newsletterTemplates.service';
export * from './newsletters.service';
import { NewslettersService } from './newsletters.service';
export * from './notificationUserSettings.service';
import { NotificationUserSettingsService } from './notificationUserSettings.service';
export * from './oPFTypes.service';
import { OPFTypesService } from './oPFTypes.service';
export * from './objectMenu.service';
import { ObjectMenuService } from './objectMenu.service';
export * from './organisation.service';
import { OrganisationService } from './organisation.service';
export * from './organisationSettings.service';
import { OrganisationSettingsService } from './organisationSettings.service';
export * from './pagesForAdmin.service';
import { PagesForAdminService } from './pagesForAdmin.service';
export * from './pagesForUser.service';
import { PagesForUserService } from './pagesForUser.service';
export * from './participantRolesForUnion.service';
import { ParticipantRolesForUnionService } from './participantRolesForUnion.service';
export * from './photo.service';
import { PhotoService } from './photo.service';
export * from './polls.service';
import { PollsService } from './polls.service';
export * from './reports.service';
import { ReportsService } from './reports.service';
export * from './role.service';
import { RoleService } from './role.service';
export * from './subscriptionsForOrganisation.service';
import { SubscriptionsForOrganisationService } from './subscriptionsForOrganisation.service';
export * from './subscriptionsForUsers.service';
import { SubscriptionsForUsersService } from './subscriptionsForUsers.service';
export * from './test.service';
import { TestService } from './test.service';
export * from './tokenWithEmail.service';
import { TokenWithEmailService } from './tokenWithEmail.service';
export * from './user.service';
import { UserService } from './user.service';
export * from './userDelete.service';
import { UserDeleteService } from './userDelete.service';
export * from './userNotification.service';
import { UserNotificationService } from './userNotification.service';
export * from './userProfile.service';
import { UserProfileService } from './userProfile.service';
export * from './userRegistration.service';
import { UserRegistrationService } from './userRegistration.service';
export * from './visibilityOptions.service';
import { VisibilityOptionsService } from './visibilityOptions.service';
export const APIS = [AppService, BusinessTypesService, BusinessTypesForUnionService, CCService, ChatsService, CitiesService, CodeSendService, CommitteeSubscriptionsService, CommitteeUserSubscriptionsService, CommitteesService, ContactsService, ContactsForUserService, CustomListsService, DashboardService, DocumentsService, EventService, InvitesService, JobTitlesService, JobTitlesForUnionService, LabelItemsService, LoyaltyService, LoyaltyCodesForProductService, LoyaltyCollectionService, LoyaltyFavoriteProductService, LoyaltyRequestsService, LoyaltySearchService, MailsService, NewsletterTemplatesService, NewslettersService, NotificationUserSettingsService, OPFTypesService, ObjectMenuService, OrganisationService, OrganisationSettingsService, PagesForAdminService, PagesForUserService, ParticipantRolesForUnionService, PhotoService, PollsService, ReportsService, RoleService, SubscriptionsForOrganisationService, SubscriptionsForUsersService, TestService, TokenWithEmailService, UserService, UserDeleteService, UserNotificationService, UserProfileService, UserRegistrationService, VisibilityOptionsService];
